import { Component, Input } from '@angular/core';
import { DialogConfig } from 'src/app/modules/shared/components/alert-dialog/dialog-config';
import { TableColumnOption } from 'src/app/modules/shared/components/table-pro/table.config';
import {
  ArchiveCatalogNameDynamicSmallTypeList,
  ArchiveCatalogNameDynamicTypeList,
} from 'src/app/modules/shared/models/archive/archive-catalog-name-dynamic-type.enum';
import { ArchiveCatalogNameRule } from 'src/app/modules/shared/models/archive/archive-catalog-name-rule.model';
import { ArchiveCatalogNameSeqTypeList } from 'src/app/modules/shared/models/archive/archive-catalog-name-seq-type.enum';
import { ArchiveCatalog } from 'src/app/modules/shared/models/archive/archive-catalog.model';
import { ArchiveKeepPeriodTypeOptions } from 'src/app/modules/shared/models/archive/archive-keep-period-type.enum';
import {
  ArchiveMaterialOrderFieldOptions,
  ArchiveOrderField,
  ArchiveOrderFieldMap,
  ArchiveRegularOrderFieldOptions,
  ArchiveWBSOrderFieldOptions,
} from 'src/app/modules/shared/models/archive/archive-order-field.enum';
import { ArchiveSortRuleInfo } from 'src/app/modules/shared/models/archive/archive-sort-rule-info.model';
import { ArchiveTitleRuleItemParamInfo } from 'src/app/modules/shared/models/archive/archive-title-rule-item-param-info.model';
import { ArchiveTitleRuleItemParamType } from 'src/app/modules/shared/models/archive/archive-title-rule-item-param-type.enum';
import { ArchiveTitleRuleItemType } from 'src/app/modules/shared/models/archive/archive-title-rule-item-type.enum';
import { ArchiveTitleRule } from 'src/app/modules/shared/models/archive/archive-title-rule.model';
import { ArchiveVolumeCreateType } from 'src/app/modules/shared/models/archive/archive-volume-create-type.enum';
import {
  ArchiveVolumeFileRule,
  ArchiveVolumeFileRuleMap,
} from 'src/app/modules/shared/models/archive/archive-volume-file-rule.enum';
import {
  ArchiveVolumePageType,
  ArchiveVolumePageTypeOptions,
} from 'src/app/modules/shared/models/archive/archive-volume-page-type.enum';
import { ArchiveVolumeType } from 'src/app/modules/shared/models/archive/archive-volume-type.enum';
import { ArchiveVolume } from 'src/app/modules/shared/models/archive/archive-volume.model';
import { ProjectItemType } from 'src/app/modules/shared/models/project/project-item-type.enum';
import { ProjectSectionItem } from 'src/app/modules/shared/models/project/project-section-item.model';
import { ProjectSection } from 'src/app/modules/shared/models/project/project-section.model';
import { NzTreeNode } from 'src/app/modules/shared/models/tree-node.model';
import { GlobalService } from 'src/app/modules/shared/providers/global.service';
import { OrderType } from 'src/app/modules/shared/providers/request/order-type.enum';
import { ArchiveCatalogService } from 'src/app/modules/shared/services/archive-catalog.service';
import { ArchiveFileService } from 'src/app/modules/shared/services/archive-file.service';
import { ArchiveVolumeService } from 'src/app/modules/shared/services/archive-volume.service';
import { ProjectSectionItemService } from 'src/app/modules/shared/services/project-section-item.service';
import {
  getWbsSectionItemIds,
  getWbsSectionOptions,
  normalizeWbsSelectionRows,
  updateWbsSelectionRows,
} from '../wbs-section-selection.utils';

@Component({
  selector: 'app-dialog-projects-profiles-volumn-edit',
  templateUrl: './dialog-projects-profiles-volumn-edit.component.html',
  styleUrls: ['./dialog-projects-profiles-volumn-edit.component.scss'],
})
export class DialogProjectsProfilesVolumnEditComponent {
  /**
   * 一个新需求，涉及范围 DialogProjectsProfilesVolumnEditComponent
   * 选择本卷对应WBS工程部位，以确定归卷文件范围：（1）可以选择多个部位，每选一个部位，则自动往下插入空白待选行（2）已选择部位，允许通过“×“删除本行（3）在选择框中，已经被上方行选中的选项，将Disable（避免重复选择）（4）为空：表示不通过这种方式划定归卷文件范围
   */
  @Input()
  data!: DialogConfig<ArchiveVolume>;

  editing: { [name: string]: boolean } = {};

  sectionNodes: Array<NzTreeNode> = [];

  ArchiveVolumeCreateType = ArchiveVolumeCreateType;

  BatchArchiveVolumeRuleList: TableColumnOption[] = [];

  ArchiveVolumePageTypeOptions = ArchiveVolumePageTypeOptions;

  ArchiveVolumePageType = ArchiveVolumePageType;

  ArchiveKeepPeriodTypeOptions = ArchiveKeepPeriodTypeOptions;

  record = new ArchiveVolume();

  batchRule = '';

  sortOrder: ArchiveOrderField[] = [];

  ArchiveOrderFieldOptions: TableColumnOption[] = [];

  ArchiveVolumeFileRule = ArchiveVolumeFileRule;

  ArchiveVolumeFileRuleMap = ArchiveVolumeFileRuleMap;

  titleRule = new ArchiveTitleRule();

  ruleItemMap: { [key: string]: ArchiveTitleRuleItemParamInfo } = {};

  ArchiveTitleRuleItemType = ArchiveTitleRuleItemType;

  ArchiveTitleRuleItemParamType = ArchiveTitleRuleItemParamType;

  parentSectionItem?: ProjectSectionItem;

  ArchiveCatalogNameSeqTypeList = ArchiveCatalogNameSeqTypeList;

  ArchiveCatalogNameDynamicTypeList = ArchiveCatalogNameDynamicTypeList;

  ArchiveCatalogNameDynamicSmallTypeList =
    ArchiveCatalogNameDynamicSmallTypeList;

  nameRule = new ArchiveCatalogNameRule();

  exampleName = '';

  sectionMap: { [key: string]: ProjectSection } = {};

  unitCascaderValues: string[][] = [[]];

  unitCascaderOptions: NzTreeNode[][] = [[]];

  dateRange: Date[] = [];

  fileCodeOrder: TableColumnOption[] = [];

  fileOrder: string[] = [];

  fileOrderEnabled = false;

  forms: { code: string; name: string }[] = [];

  volumeType: ArchiveVolumeType = ArchiveVolumeType.REGULAR;

  ArchiveVolumeType = ArchiveVolumeType;

  catalog = new ArchiveCatalog();

  get autoCount() {
    switch (this.volumeType) {
      case ArchiveVolumeType.WBS:
        return 11;
      case ArchiveVolumeType.MATERIAL:
        return 8;
      case ArchiveVolumeType.REGULAR:
        return 9;
    }
  }

  onDateRangeChange(dates: Date[]) {
    this.dateRange = dates;
  }

  constructor(
    private projectSectionItemService: ProjectSectionItemService,
    private archiveVolumeService: ArchiveVolumeService,
    private archiveFileService: ArchiveFileService,
    private archiveCatalogService: ArchiveCatalogService,
    private globalService: GlobalService,
  ) {}

  ngOnInit() {
    this.handleDataBeforeInit(this.data.data!);
  }

  private getSectionItem() {
    if (this.record.sectionId) {
      this.projectSectionItemService
        .tree({
          projectId: this.globalService.projectId,
          type: ProjectItemType.SECTION,
          sectionId: this.record.sectionId,
        })
        .subscribe((res) => {
          const sectionRoot = res.child![0];
          const node = this.catalog.sectionItemId
            ? (this.findSectionItem(this.catalog.sectionItemId, sectionRoot) ??
              sectionRoot)
            : sectionRoot;
          this.parentSectionItem = node;
          const treeNode: NzTreeNode[] = [];
          treeNode.push(this.buildTreeNodes(node, true));
          this.sectionNodes = treeNode;

          const selectedIds =
            this.record.sectionItemIds !== undefined
              ? this.record.sectionItemIds
              : this.record.sectionItemId
                ? [+this.record.sectionItemId]
                : [];
          const selectedPaths = selectedIds
            .map((sectionItemId) =>
              this.searchTreeNode(`${sectionItemId}`, node),
            )
            .filter((path): path is string[] => !!path);
          this.unitCascaderValues = normalizeWbsSelectionRows(selectedPaths);
          this.refreshUnitCascaderOptions();
        });
    } else {
      this.refreshUnitCascaderOptions();
    }
    if (this.volumeType === ArchiveVolumeType.REGULAR) {
      this.archiveFileService
        .listFormInfoByCatalogId(this.record.catalogId!)
        .subscribe((res) => {
          const fileOrder: TableColumnOption[] = [];
          for (const file of res) {
            fileOrder.push({
              label: (file.code ?? '') + ' ' + (file.name ?? ''),
              value: file.code!,
            });
          }
          this.fileCodeOrder = fileOrder;
          this.forms = res;
          this.onFileOrderSelected();
        });
    }
  }

  private handleDataBeforeInit(response: ArchiveVolume) {
    this.record = JSON.parse(JSON.stringify(response)) as ArchiveVolume;
    console.log('this.record', this.record);
    if (
      !!this.record.sectionItemId ||
      (this.record.sectionItemIds && this.record.sectionItemIds.length > 0) ||
      !!this.record.dwTypeCode
    ) {
      this.volumeType = ArchiveVolumeType.WBS;
    }
    if (!!this.record.isMaterial) {
      this.volumeType = ArchiveVolumeType.MATERIAL;
    }
    switch (this.volumeType) {
      case ArchiveVolumeType.WBS:
        this.ArchiveOrderFieldOptions = ArchiveWBSOrderFieldOptions;
        break;
      case ArchiveVolumeType.MATERIAL:
        this.ArchiveOrderFieldOptions = ArchiveMaterialOrderFieldOptions;
        break;
      default:
        this.ArchiveOrderFieldOptions = ArchiveRegularOrderFieldOptions;
        break;
    }
    const ordered = this.record.sortRules!.sort((a, b) => a.order! - b.order!);
    this.sortOrder = ordered.map((item) => item.orderField!);
    const fileOrderRule = ordered.find(
      (x) => x.orderField === ArchiveOrderField.FORM_CODE,
    );
    if (fileOrderRule && fileOrderRule.formCodes) {
      this.fileOrder = fileOrderRule.formCodes;
    }
    if (this.record.startTime && this.record.finishTime) {
      this.dateRange = [
        new Date(this.record.startTime),
        new Date(this.record.finishTime),
      ];
    }
    if (
      this.record.fileRule === ArchiveVolumeFileRule.FULL_FILES &&
      this.record.createType === ArchiveVolumeCreateType.MANUAL &&
      this.volumeType !== ArchiveVolumeType.WBS
    ) {
      if (this.record.fileFinishDateFrom) {
        this.record.fileFinishDateFromDate = new Date(
          this.record.fileFinishDateFrom,
        );
      }
      if (this.record.fileFinishDateTo) {
        this.record.fileFinishDateToDate = new Date(
          this.record.fileFinishDateTo,
        );
      }
    }
    this.onOrderSelected();
    if (this.record.catalogId && this.volumeType === ArchiveVolumeType.WBS) {
      this.archiveCatalogService
        .findById(this.record.catalogId)
        .subscribe((res) => {
          this.catalog = res;
          this.getSectionItem();
        });
    } else {
      this.getSectionItem();
    }
  }

  private buildTreeNodes(
    item: ProjectSectionItem,
    hasAllNode?: boolean,
  ): NzTreeNode {
    const node: NzTreeNode = {
      label:
        item.type !== ProjectItemType.PROJECT_SECTION
          ? item.code + ' ' + item.name
          : item.name,
      value: `${item.type}#${item.id}`,
      children: [],
      isLeaf: false,
    };
    for (const child of item.child ?? []) {
      if (
        item.type === ProjectItemType.PROJECT_SECTION &&
        !!this.catalog.dwTypeCode
      ) {
        if (child.code && child.code.indexOf(this.catalog.dwTypeCode) >= 0) {
          node.children!.push(this.buildTreeNodes(child, hasAllNode));
        }
      } else {
        node.children!.push(this.buildTreeNodes(child, hasAllNode));
      }
    }
    if (node.children?.length === 0) {
      node.isLeaf = true;
      node.children = undefined;
    } else if (hasAllNode) {
      node.children!.unshift({
        label: '全部',
        value: `${item.type}#${item.id}`,
        isLeaf: true,
      });
    }
    return node;
  }

  private findSectionItem(
    sectionItemId: number,
    node: ProjectSectionItem,
  ): ProjectSectionItem | null {
    if (node.id === sectionItemId) {
      return node;
    }
    for (const child of node.child ?? []) {
      const found = this.findSectionItem(sectionItemId, child);
      if (found) {
        return found;
      }
    }
    return null;
  }

  private searchTreeNode(
    sectionItemId: string,
    node: ProjectSectionItem,
  ): string[] | null {
    if (`${node.id}` === `${sectionItemId}`) {
      if (node.type === ProjectItemType.SECTION) {
        return [`${node.type}#${node.id}`];
      } else {
        return [`${node.type}#${node.id}`, `${node.type}#${node.id}`];
      }
    }
    for (const child of node.child ?? []) {
      const found = this.searchTreeNode(sectionItemId, child);
      if (found) {
        return [`${node.type}#${node.id}`, ...found];
      }
    }
    return null;
  }

  onUnitCascaderChange(index: number, value: string[] | null) {
    this.unitCascaderValues = updateWbsSelectionRows(
      this.unitCascaderValues,
      index,
      value,
    );
    this.refreshUnitCascaderOptions();
  }

  removeUnitCascader(index: number) {
    this.onUnitCascaderChange(index, null);
  }

  private refreshUnitCascaderOptions() {
    this.unitCascaderOptions = this.unitCascaderValues.map((_, index) =>
      getWbsSectionOptions(this.sectionNodes, this.unitCascaderValues, index),
    );
  }

  onOrderSelected() {
    setTimeout(() => {
      const copy = JSON.parse(JSON.stringify(this.ArchiveOrderFieldOptions));
      for (const item of copy) {
        const index = this.sortOrder.indexOf(item.value as ArchiveOrderField);
        item.label =
          index >= 0
            ? `排序(${index + 1}) ${
                ArchiveOrderFieldMap[item.value as ArchiveOrderField]
              }`
            : ArchiveOrderFieldMap[item.value as ArchiveOrderField];
      }
      this.ArchiveOrderFieldOptions = copy;
      if (this.sortOrder.indexOf(ArchiveOrderField.FORM_CODE) < 0) {
        this.fileOrder = [];
        this.fileOrderEnabled = false;
      } else {
        this.fileOrderEnabled = true;
      }
    }, 50);
  }

  onFileOrderSelected() {
    setTimeout(() => {
      const copy = JSON.parse(JSON.stringify(this.fileCodeOrder));
      for (let i = 0; i < copy.length; i++) {
        const index = this.fileOrder.indexOf(copy[i].value.toString());
        copy[i].label =
          index >= 0
            ? `排序(${index + 1}) ${this.forms[i].code} ${this.forms[i].name}`
            : `${this.forms[i].code} ${this.forms[i].name}`;
      }
      this.fileCodeOrder = copy;
    }, 50);
  }

  isNaN(content: number) {
    return window.isNaN(content);
  }

  cancel() {
    this.data.onCancel();
  }

  confirm() {
    this.submit();
  }

  private handleDataBeforeConfirm(response: ArchiveVolume): ArchiveVolume {
    const data = JSON.parse(JSON.stringify(response)) as ArchiveVolume;
    const sortRules: Array<ArchiveSortRuleInfo> = [];
    let index = 0;
    for (const orderField of this.sortOrder) {
      const rule: ArchiveSortRuleInfo = {
        orderField,
        orderType: OrderType.ASC,
        order: index++,
      };
      if (orderField === ArchiveOrderField.FORM_CODE) {
        rule.formCodes = this.fileOrder;
      }
      sortRules.push(rule);
    }
    data.sortRules = sortRules;
    data.sectionId = this.catalog.sectionId;
    if (
      data.createType === ArchiveVolumeCreateType.MANUAL &&
      this.volumeType === ArchiveVolumeType.WBS
    ) {
      data.sectionItemIds = getWbsSectionItemIds(this.unitCascaderValues);
    }
    if (this.dateRange.length === 2) {
      data.startTime = new Date(this.dateRange[0]).getTime();
      data.finishTime = new Date(this.dateRange[1]).getTime();
    } else {
      data.startTime = undefined;
      data.finishTime = undefined;
    }

    if (!data.sectionItemIds || data.sectionItemIds?.length === 0) {
      if (this.catalog.sectionItemId) {
        data.sectionItemIds = [this.catalog.sectionItemId];
      }
    }

    return data;
  }

  get canConfirm() {
    if (!this.record.title || this.record.title.trim() === '') {
      return false;
    }
    if (this.sortOrder.length === 0) {
      return false;
    }
    if (this.dateRange.length === 0) {
      return false;
    }
    if (this.sortOrder.includes(ArchiveOrderField.FORM_CODE)) {
      if (!this.fileOrder || this.fileOrder.length === 0) {
        return false;
      }
    }
    return true;
  }

  private submit() {
    this.archiveVolumeService
      .update(this.handleDataBeforeConfirm(this.record))
      .subscribe((response: boolean) => {
        if (response) {
          this.data.onConfirm!();
        }
      });
  }
}
